export default "__VITE_ASSET__26ab5d3f__"